(() => {
  const SELECTORS = {
    quickDropdown: '[data-lc-quick-size]',
    quickTrigger: '[data-lc-quick-trigger]',
    quickOption: '[data-lc-quick-option]',
    quickForm: '[data-lc-quick-form]',
    dotsHost: '.product-section .product__media-list',
    productRoot: '[data-lc-product-root]',
    sticky: '[data-lc-sticky-atc]'
  };

  const setQuickMenuState = (dropdown, isOpen) => {
    dropdown.closest('.card-wrapper')?.classList.toggle('lc-quick-size-open', isOpen);
    dropdown.closest('.collection-product-card')?.classList.toggle('lc-quick-size-open', isOpen);
  };

  const getQuickMenu = (dropdown) => dropdown._lcQuickMenu || dropdown.querySelector('.lc-quick-size-menu');

  const positionQuickMenu = (dropdown) => {
    const menu = getQuickMenu(dropdown);
    const trigger = dropdown.querySelector(SELECTORS.quickTrigger);
    if (!menu?.classList.contains('lc-quick-size-menu--portal') || !trigger) return;
    const rect = trigger.getBoundingClientRect();
    menu.style.top = `${rect.bottom + 3}px`;
    menu.style.left = `${rect.left}px`;
    menu.style.width = `${rect.width}px`;
    menu.style.maxHeight = `${Math.max(120, window.innerHeight - rect.bottom - 8)}px`;
  };

  const openQuickMenu = (dropdown) => {
    const menu = getQuickMenu(dropdown);
    if (!menu || menu.classList.contains('lc-quick-size-menu--portal')) return;
    const anchor = document.createComment('lc-quick-size-menu-anchor');
    menu.before(anchor);
    dropdown._lcQuickMenu = menu;
    dropdown._lcQuickMenuAnchor = anchor;
    document.body.append(menu);
    menu.classList.add('lc-quick-size-menu--portal');
    positionQuickMenu(dropdown);
  };

  const closeQuickMenu = (dropdown) => {
    const menu = getQuickMenu(dropdown);
    const anchor = dropdown._lcQuickMenuAnchor;
    dropdown.classList.remove('is-open');
    setQuickMenuState(dropdown, false);
    dropdown.querySelector(SELECTORS.quickTrigger)?.setAttribute('aria-expanded', 'false');
    if (menu?.classList.contains('lc-quick-size-menu--portal') && anchor?.parentNode) {
      anchor.replaceWith(menu);
      menu.classList.remove('lc-quick-size-menu--portal');
      menu.removeAttribute('style');
    }
    delete dropdown._lcQuickMenu;
    delete dropdown._lcQuickMenuAnchor;
  };

  const closeQuickMenus = (except) => {
    document.querySelectorAll(SELECTORS.quickDropdown).forEach((dropdown) => {
      if (dropdown === except) return;
      closeQuickMenu(dropdown);
    });
  };

  const initQuickAdd = (scope = document) => {
    scope.querySelectorAll(SELECTORS.quickDropdown).forEach((dropdown) => {
      if (dropdown.dataset.lcReady === 'true') return;
      dropdown.dataset.lcReady = 'true';
      const trigger = dropdown.querySelector(SELECTORS.quickTrigger);
      const form = dropdown.closest(SELECTORS.quickForm)?.querySelector('form');
      const idInput = form?.querySelector('[name="id"]');
      const addButton = form?.querySelector('[name="add"]');
      if (!trigger || !idInput || !addButton) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const opening = !dropdown.classList.contains('is-open');
        closeQuickMenus(dropdown);
        if (opening) {
          dropdown.classList.add('is-open');
          setQuickMenuState(dropdown, true);
          trigger.setAttribute('aria-expanded', 'true');
          openQuickMenu(dropdown);
        } else {
          closeQuickMenu(dropdown);
        }
      });

      dropdown.querySelectorAll(SELECTORS.quickOption).forEach((option) => {
        option.addEventListener('click', () => {
          idInput.value = option.dataset.variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.querySelector('[data-lc-quick-label]').textContent = option.dataset.variantLabel;
          addButton.disabled = false;
          addButton.removeAttribute('aria-disabled');
          closeQuickMenu(dropdown);
        });
      });
    });
  };

  const initGalleryDots = (scope = document) => {
    scope.querySelectorAll(SELECTORS.dotsHost).forEach((host) => {
      if (host.dataset.lcDotsReady === 'true') return;
      const sliderElement = host.querySelector('.js-media-list');
      if (!sliderElement) return;

      const mountDots = () => {
        const swiper = sliderElement.swiper;
        if (!swiper || host.dataset.lcDotsReady === 'true') return false;
        const slides = [...swiper.slides].filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));
        if (slides.length < 2) return true;
        host.dataset.lcDotsReady = 'true';
        const dots = document.createElement('div');
        dots.className = 'lc-mobile-product-dots';
        dots.setAttribute('aria-label', 'Product images');
        slides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lc-mobile-product-dot';
          dot.setAttribute('aria-label', `Image ${index + 1}`);
          dot.addEventListener('click', () => swiper.slideToLoop ? swiper.slideToLoop(index) : swiper.slideTo(index));
          dots.appendChild(dot);
        });
        host.insertAdjacentElement('afterend', dots);
        const update = () => {
          const activeIndex = swiper.realIndex ?? swiper.activeIndex;
          [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
        };
        swiper.on('slideChange', update);
        update();
        return true;
      };

      if (!mountDots()) {
        let retries = 0;
        const timer = window.setInterval(() => {
          retries += 1;
          if (mountDots() || retries > 30) window.clearInterval(timer);
        }, 100);
      }
    });
  };

  /* Shopify products can mix portrait, square, and landscape assets. Make the
     active slide determine the carousel height on every product template. */
  const initAdaptiveProductGalleries = (scope = document) => {
    scope.querySelectorAll('.product-section .js-media-list').forEach((sliderElement) => {
      if (sliderElement.dataset.lcAdaptiveGalleryReady === 'true') return;

		const mount = () => {
			const swiper = sliderElement.swiper;
			if (!swiper || swiper.destroyed) return false;
			let viewportWidth = document.documentElement.clientWidth;

        sliderElement.dataset.lcAdaptiveGalleryReady = 'true';
        swiper.params.autoHeight = true;

        const syncHeight = () => {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
          window.requestAnimationFrame(() => {
            if (swiper.destroyed) return;
            const activeSlide = swiper.slides[swiper.activeIndex];
            const image = activeSlide?.querySelector('.product__media:not(.product__media-deferred) img');
            const width = activeSlide?.getBoundingClientRect().width || sliderElement.clientWidth;
            const fallbackPadding = Number.parseFloat(
              activeSlide?.querySelector('.product__media')?.style.getPropertyValue('--lc-media-padding-top')
            );
            const ratio = image?.naturalWidth
              ? image.naturalHeight / image.naturalWidth
              : (fallbackPadding ? fallbackPadding / 100 : 0);
            const height = width * ratio;
            if (Number.isFinite(height) && height > 0) {
              sliderElement.style.setProperty('--lc-active-media-height', `${Math.round(height)}px`);
            }
            swiper.updateAutoHeight(260);
          });
        };

        sliderElement.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', syncHeight, { once: true });
        });
        swiper.on('slideChangeTransitionStart', syncHeight);
        swiper.on('slideChangeTransitionEnd', syncHeight);
        swiper.on('imagesReady', syncHeight);
		// Ignore height-only viewport changes generated by mobile browser chrome
		// during vertical scrolling. Heights still update after a horizontal slide
		// change, image load, or a real width/orientation change.
		window.addEventListener('resize', () => {
			const nextViewportWidth = document.documentElement.clientWidth;
			if (nextViewportWidth === viewportWidth) return;
			viewportWidth = nextViewportWidth;
			window.setTimeout(syncHeight, 250);
		}, { passive: true });
        syncHeight();
        return true;
      };

      if (mount()) return;
      let retries = 0;
      const timer = window.setInterval(() => {
        retries += 1;
        if (mount() || retries > 30) window.clearInterval(timer);
      }, 100);
    });
  };

  const initStickyAtc = (scope = document) => {
    scope.querySelectorAll(SELECTORS.productRoot).forEach((root) => {
      if (root.dataset.lcStickyReady === 'true') return;
      const sticky = root.querySelector(SELECTORS.sticky);
      if (!sticky || !sticky.dataset.productForm) return;
      const mainForm = root.querySelector(`#${CSS.escape(sticky.dataset.productForm)}`);
      const stickyForm = sticky?.querySelector('form');
      const stickySelect = sticky?.querySelector('[data-lc-sticky-variant]');
      const stickyButton = sticky?.querySelector('[name="add"]');
      const mainInput = mainForm?.querySelector('[name="id"]');
      if (!sticky || !stickyForm || !stickyButton || !mainInput) return;
      root.dataset.lcStickyReady = 'true';

      const syncFromMain = () => {
        if (!stickySelect) {
          stickyButton.disabled = mainInput.disabled;
          return;
        }
        const option = stickySelect.querySelector(`option[value="${CSS.escape(mainInput.value)}"]`);
        if (!option) return;
        stickySelect.value = mainInput.value;
        stickyButton.disabled = option.disabled;
        sticky.querySelector('[data-lc-sticky-price]').textContent = option.dataset.price || '';
      };
      const syncFromSticky = () => {
        const option = stickySelect.options[stickySelect.selectedIndex];
        stickyForm.querySelector('[name="id"]').value = stickySelect.value;
        stickyButton.disabled = option.disabled;
        sticky.querySelector('[data-lc-sticky-price]').textContent = option.dataset.price || '';
      };
      mainInput.addEventListener('change', syncFromMain);
      stickySelect?.addEventListener('change', syncFromSticky);
      syncFromMain();

      const updateVisibility = () => {
        const page = document.documentElement;
        const scrollableHeight = page.scrollHeight - window.innerHeight;
        const scrollProgress = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0;
        const showAfter = Number.parseFloat(sticky.dataset.showAfter || '50') / 100;
        sticky.classList.toggle('is-visible', scrollProgress >= showAfter);
      };
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
    });
  };

  const init = (scope = document) => {
    initQuickAdd(scope);
    initAdaptiveProductGalleries(scope);
    initGalleryDots(scope);
    initStickyAtc(scope);
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest(SELECTORS.quickDropdown)) closeQuickMenus();
  });
  window.addEventListener('scroll', () => closeQuickMenus(), { passive: true });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
